import React from "react";

/** Quiet static footer with the synod help contacts. */
function Footer() {
  return (
    <footer className="sl-footer">
      <div className="container-fluid px-3 d-flex flex-wrap gap-2 justify-content-between">
        <span>Anglican Diocese of Melbourne — Synod</span>
        <span>
          Help desk <a href="tel:0396534282">9653 4282</a> · <a href="mailto:synod@melbourneanglican.org.au">synod@melbourneanglican.org.au</a>
        </span>
      </div>
    </footer>
  );
}

export default Footer;
